import { render, staticRenderFns } from "./inventoryOverTopForm.vue?vue&type=template&id=6228e082&scoped=true&"
import script from "./inventoryOverTopForm.vue?vue&type=script&lang=js&"
export * from "./inventoryOverTopForm.vue?vue&type=script&lang=js&"
import style0 from "./inventoryOverTopForm.vue?vue&type=style&index=0&id=6228e082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228e082",
  null
  
)

export default component.exports